import React from "react";
import classNames from "classnames";
import { MiniBar } from "./components";
import Badge from "../../../theme/untitled/Badge/Badge";
import Icon from "../../../theme/untitled/icons/Icon";
import {
  formatDate,
  daysAgo,
  daysToGo,
  getRatio,
  getRatioMeta,
  RATIO_BADGE_COLOR,
} from "./utils";

const DAYS_TO_GO_WARNING_THRESHOLD = 3;

function DaysToGo({ dtg }) {
  if (dtg === 0) {
    return (
      <Badge color="warning" dot className="eew-badge-today">
        Today
      </Badge>
    );
  }
  if (dtg >= 1 && dtg <= DAYS_TO_GO_WARNING_THRESHOLD) {
    return (
      <Badge color="warning" dot>
        {dtg} {dtg === 1 ? "day" : "days"}
      </Badge>
    );
  }
  return (
    <span className="eew-dtg">
      {dtg}
      <span className="eew-dtg-unit">days</span>
    </span>
  );
}

/**
 * @param {Object}    props
 * @param {EventStat} props.event
 * @param {number}    props.sharedMax
 * @param {boolean}   props.isExpanded
 * @param {Function}  props.onToggle
 * @param {"past"|"upcoming"} props.variant
 */
export default function EventRow({
  event,
  sharedMax,
  isExpanded,
  onToggle,
  variant,
}) {
  const isPast = variant === "past";
  const ratio = isPast ? getRatio(event.impressions, event.views) : null;
  const ratioMeta = ratio !== null ? getRatioMeta(ratio) : null;
  const dtg = !isPast ? daysToGo(event.date) : null;
  const eventDate = formatDate(event.date);

  return (
    <tr
      className={classNames("eew-data-row", {
        "eew-data-row--expanded": isExpanded,
      })}
      onClick={onToggle}
    >
      <td className="eew-col-event">
        <div className="eew-event-cell">
          <div className="eew-event-name">{event.name}</div>
          <div className="eew-event-meta">
            {eventDate}
            {isPast && ` · ${daysAgo(event.date)}`}
          </div>
        </div>
      </td>

      <td className="eew-col-metric text-right">
        <MiniBar value={event.impressions} max={sharedMax} color="imp" />
      </td>

      <td className="eew-col-metric text-right">
        <MiniBar value={event.views} max={sharedMax} color="views" />
      </td>

      {isPast ? (
        <td className="eew-col-when text-right">
          {ratioMeta ? (
            <Badge color={RATIO_BADGE_COLOR[ratioMeta.level]}>{ratio}%</Badge>
          ) : (
            <span className="eew-ratio-empty">—</span>
          )}
        </td>
      ) : (
        <td className="eew-col-when text-right">
          <DaysToGo dtg={dtg} />
        </td>
      )}

      <td className="eew-col-chevron text-right">
        <button
          type="button"
          className="eew-expand-btn"
          aria-expanded={isExpanded}
          aria-label={`Views by source for ${event.name}, ${eventDate}`}
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
        >
          <Icon name="ChevronRight" size={16} />
        </button>
      </td>
    </tr>
  );
}
